// extracted by mini-css-extract-plugin
export default {"container":"filedrop__container___hZJwm","drag":"filedrop__drag___Syd7Z","over":"filedrop__over___xq3XN"};